
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import React, {useState,useRef,useEffect } from "react";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Stack from '@mui/material/Stack';
import { getBotListFromLibrary, setupBotSchedule, getBotSchedulesByEnv,deleteItemsFromBotSchedules} from "../../apis/bots";
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';      

import { Table } from "../GenericReusableComponents/Table";
import {SelectEnvironment,SimpleButton,SelectInput,TButton} from "../GenericReusableComponents/HTMLWrappers"
import Grid from "@mui/material/Grid";
import { SelectList } from "./SelectBots";
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import { LightTooltip } from '../LightTooltip';

// import CreateSchedule from "../CreateSchedule";

export function ScheduleBot({ showScheduleBot, setShowScheduleBot}){

    const[selectedEnv,setSelectedEnv] = useState("PROD");
    const[schedules,setSchedules] = useState([]);
    // const[orgSchedule,setOrgSchedule] = useState([]);
    const[showSchedule,setShowSchedule] = useState([false]);
    const[botsChanged,setBotsChanged] = useState(false);
    const[enableAddToScheduleButton,setEnableAddToScheduleButton] = useState(false);
    const[enableScheduleButton,setEnableScheduleButton] = useState(false);
    const[scheduleStatus,setScheduleStatus] = useState("");
    const[localBots,setLocalBots] = useState([]);
   
    const [scheduleName, setScheduleName] = useState('');
    // const [frequency, setFrequency] = useState('');
    // const [rangeFrom, setRangeFrom] = useState('');
    // const [rangeTo, setRangeTo] = useState('');
    const [cron, setCron] = useState('?,4,*,*,*');
    const [timezone, setTimezone] = useState('UTC');
    
    useEffect(() => {
        if (!showScheduleBot) {
          return;
        }
      
        let mounted = true;
      
        if (mounted) {
          getData(selectedEnv);
          setScheduleStatus("");
        }
      
        return () => {
          mounted = false;
        };
      }, [botsChanged, showScheduleBot]);
      
      

    
    const envList = [
        "DEV",
        "QA",
        "UAT",
        "PROD"
    ]

    


    function getData(env){
        // console.log(`Inside getData for ${env}`)
        
        // getBotListFromLibrary().then((botList)=>{
        //     if(Array.isArray(botList)){
        //         setBots(botList);
        //     }else{
        //         setBots([]);
        //     }
        // })
        getLocalBots()
        var sched = []
        setSchedules(sched)
        return


        getBotSchedulesByEnv(env).then((scheduleList)=>{
            
            
            for(let i=0; i<scheduleList.length;i++){
                scheduleList[i].key = i;
            }
            setSchedules(scheduleList);

        })

       // This is added to deal with close and reopen
        unCheckBoxs();
        setEnableScheduleButton(false);
        setEnableAddToScheduleButton(false);

    }
    function getSTableHeader(){
        return (
            <tr>
            <th>Select Schedule</th>
            <th></th>
            </tr>
        )
    }

    function getSTableBody(){
        return(
            <div className = 'myform'>
            <tr>
            <label>
                Schedule Name
            </label>
            </tr>
            <tr>
            <input
                className='editvalue'
                type="text"
                value={scheduleName}
                onChange={(e) =>    setScheduleName(e.target.value) }
                />

            </tr>
            <br />
            <tr>
            <label>
                Frequency (Cron)
            </label>
            </tr>
            <tr>
            <input
                className='editvalue'
                type="text"
                value={cron}
                onChange={(e) => setCron(e.target.value)}
                />

            <br />
            </tr>
            <tr>
            <label>
                Timezone
            </label>
            </tr>
            <tr>
                <input
                className='editvalue'
                type="text"
                value={timezone}
                onChange={(e) => setTimezone(e.target.value)}
                />
            <br />
            </tr>

            <tr>
                {/* <CreateSchedule/> */}
            <br />
            </tr>


        </div>
        )
    }

    
    function getLocalBots(){

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json'}
          }
      
          fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/list/'  , requestOptions)
          .then (async response => {
            const data = await response.json();
            if (!response.ok) 
            {
              const error = (data && data.message) || response.status;
              console.log(error)
              return Promise.reject(error);
      
            }
            var bots = [];
            for (var i = 0; i < data.length; i++) {
                var ob = {}
                ob.botName = data[i];
                bots.push(ob);
            }
            console.log("local bots:" + bots)

            setLocalBots(bots)
          })
    
          .catch(error => {alert(error)});
    
    }

    function getSBTableHeader(){
        return (
            <tr>
            <th>Select Bots</th>
            <th></th>
            </tr>
        )
    }


        function renderLocalBots(listOfBots){
            console.log(listOfBots)
            return  listOfBots.map( bot => 
                (
                    
                   
                    <tr>
                        <td>
                        <FormControlLabel 
                            control={
                                <Checkbox 
                                    name={bot.botName}
                                    checked={bot.isChecked}
                                    onChange={e => {
                                        
                                        console.log(`${e.target.name} ${e.target.checked}` );
                                        let lbots = [...localBots];
                                        let i = lbots.findIndex(b=> b.botName === e.target.name);
                                        console.log(`Index ${i}`)
                                        lbots[i].isChecked = e.target.checked;                          
                                        setLocalBots([...lbots]);
    
                                        if(isBotAndScheduleSelected()){
                                            setEnableAddToScheduleButton(true);
                                        }
    
                                    }}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                
                            } 
                            label={bot.botName}/>
                        </td>
                    </tr>
                )
            )}
    
            function isBotAndScheduleSelected(){
                let checkedLocalBots = localBots.filter(b => b.isChecked === true);
                let checkedSchedule = true;
                let checkedB =  checkedLocalBots.length != 0 && checkedSchedule
                setEnableAddToScheduleButton(checkedB)
                }
        

    function getSBTableBody(){
        return ( 
            <>
                {/* <label>Library Bots</label> */}
                {/* {renderBots(bots)} */}
                {renderLocalBots(localBots)}

                {/* <label>Local Bots</label> */}
            </>
            )
    }



    const SelectSchedule =()=>{
        const tbScrollStyle={
            margin:'0px',
            padding:'0px'
            
        }

        const tbStyle={
            margin:'0px',
            padding:'0px',
            width:"95%"
        }
    
        const tbContainerStyle={
            margin:'0px',
            padding:'0px'
        }

        return(
            <>
            <Table
            columns={getSTableHeader()}
            rows={getSTableBody()}
            tbcontainerstyle={tbContainerStyle}
            tbscrollstyle={tbScrollStyle}
            tbstyle={tbStyle}
            />
            </>

        )
    }


    const SelectBots=()=>{
        const tbScrollStyle={
            margin:'0px',
            padding:'0px'
        }
    
        const tbContainerStyle={
            margin:'0px',
            padding:'0px'
        }

        const tbStyle={
            margin:'0px',
            padding:'0px'
        }

       
        return(
            <Table
            columns={getSBTableHeader()}
            rows={getSBTableBody()}
            tbcontainerstyle={tbContainerStyle}
            tbscrollstyle={tbScrollStyle}
            tbstyle={tbStyle}
            />
        )
    }




    function getRowStyle(item){
        
        let trStyle = {
            height : '60px'
        }
        if(item.isNewAdded){
            trStyle.backgroundColor = 'white';
            
        }
        return trStyle;
    }

   
    
    function getDPTableHeader(){
        const columns = ["Bot Name","Schedule Name","Frequency", "Timezone"];
        return(
            columns.map(i =>(
                <th>{i}</th>
              ))
        )

    }

    function removeFromSchedules(e, item){

    }

    function getDPTableBody(){
        return schedules.map(item => (
            <tr style={getRowStyle(item)}>
                <td>{item.botName}</td>
                <td>{item.scheduleName}</td>
                <td>{item.frequency}</td>
                <td style={{textAlign:'center'}}>
                    <button onClick={e => removeFromSchedules(e,item)}>X</button>                 
                </td>
            </tr>
        ))
    }
    const Schedule = () =>{
        
        
        console.log(`Selected Env :  ${selectedEnv}`)
        const tbStyle = {
            // width:"98%"
            width:"100%"
        }

        const tbContainerStyle={
            margin:'0px 0px 0px 10px',
            padding:'0px'
        }


        return(
            <>
           
            {/* <h3 style={{textAlign:"center"}}>Deployment Profile</h3> */}

            <Table columns={getDPTableHeader()} rows={getDPTableBody()}  tbstyle={tbStyle} tbcontainerstyle={tbContainerStyle} />

            {/* {!(selectedEnv === 'PROD' || deploymentProfile.length === 0) && <SimpleButton sname={promotionText} enable={enablePromoteButton} onClickHandler={promoteToNextEnv}/>} */}
           
           
            </>
        )
    }

    function addToSchedule(e){
    }


    function scheduleBots(e){
        e.preventDefault();
        // console.log("Deployment Profile "+ JSON.stringify(deploymentProfile));
        setScheduleStatus("Scheduling.....");
        // if(isNewDeploymentProfileEqToOrg(deploymentProfile)){
        //     console.log("No changes to deployment profile");
        //     return
        // }
        // TODO: get the schedules in here
        var scheduleItems = []
        let newItemsInDp = scheduleItems.map(item =>{
            return {botName: item.botName}
        })

        setupBotSchedule(newItemsInDp,selectedEnv);

        // let ldeploymentProfile = [...deploymentProfile];
        // ldeploymentProfile.forEach(i => i.isNewAdded = false);
        // setDeploymentProfile(ldeploymentProfile);
    
        setEnableScheduleButton(false);
       
    }


    


    function unCheckBoxs(){
        let lbots = [...localBots];
        lbots.forEach(b => b.isChecked = false);
        setLocalBots(lbots);

    }
      
    
    function closeModal(){
        
        unCheckBoxs();
        setShowScheduleBot(false);
    }

    const disabledButtonStyle = {
            display:'flex', 
            // marginTop:'65px',
            marginTop:'10px',
            marginLeft:'35px',
            // height:'75px',
            // width:'150px',
            fontWeight:'bold',
            color:'lightgrey',
            backgroundColor:'grey',

        }

    const buttonStyle = {
        display:'flex', 
        marginTop:'10px',
        marginLeft:'35px',
        // marginTop:'65px',
        // height:'75px',
        // width:'150px',
        fontWeight:'bold',
        color:'white',
        backgroundColor:'royalblue',
        textTransform: 'none',
        "&:hover": {
            backgroundColor: '#244784'
          },        

    }

    function onSelectEnv(e){
        e.preventDefault();
        console.log(`onSelectEnv ${e.target.value}`)
        setSelectedEnv(e.target.value);
        getData(e.target.value);

    }

    const renderScheduleButton=()=>{
        if (enableScheduleButton)
        return(
            <div>
                <LightTooltip title="Schedule Bots">
                <button className="ipc dialogbtn" style={{margin:'10px'}} onClick={scheduleBots}>
                Schedule
                </button>
                </LightTooltip>
             </div>

        )
        else
        return(
            <div>
                <LightTooltip title="Schedule Bots">
                <button disabled className="ipc dialogbtn" style={{margin:'10px'}} onClick={scheduleBots}>
                Schedule
                </button>
                </LightTooltip>
             </div>

        )

    }
    if (!showScheduleBot) {
        return "";
    }



    return(
        <div className="modal">
            <div className="deploybot-modal-content">
          
                
                <Tooltip title="Close">
                    <IconButton
                        style={{ float: "right", position: "absolute", right: 0, top: 0 }}
                        onClick={() => setShowScheduleBot(false)}
                    >
                        <CloseOutlinedIcon />
                    </IconButton>
                </Tooltip>
                <form>
                        <Grid container spacing={0}>
                            <Grid item xs={12} style={{paddingBottom:'50px'}}>
                                <SelectEnvironment selectedEnv={selectedEnv} onChangeHandler={onSelectEnv}/>
                            </Grid>
                            {/* <Grid item xs={12}>
                                <p>{deployStatus}</p>
                            </Grid> */}
                            {/* <Grid item xs={1}>
                                <SelectBots />
                            </Grid>
                            <Grid item xs={2}>
                                <SelectSchedule/>
                            </Grid> */}
                                 
                                    {/* <Grid item xs={12}>
                                        
                                        <SimpleButton sname="Add To Deployment Profile" enable={enableAddToDeploymentProfileButton} onClickHandler={addToDeploymentProfile}/>
                                    </Grid> */}

                            <div>
                                {SelectBots()}
                            </div>

                            <div>
                                {SelectSchedule()}
                            </div>

                            <div>
                                <LightTooltip title="Add to Schedule">
                               <IconButton 
                                    onClick={addToSchedule}
                                    // classes={{ root: buttonStyle, disabled: disabledButtonStyle }}                                    
                                    style={buttonStyle}
                                    disabled={!enableAddToScheduleButton}
                                >
                                    <DoubleArrowIcon fontSize="inherit" />
                                    </IconButton>
                                </LightTooltip>    
                            </div>

                            <div>
                            {Schedule()}

                                {/* <Schedule/> */}
                            </div>
                           
                            {/* <Grid item xs={5.5}>
                                <Schedule/>
                            </Grid> */}

                            <Grid item xs={1.5}>
                                {renderScheduleButton()}
                            </Grid>


                                
                           
                        </Grid>
                                
                                {/* <Divider orientation="vertical" flexItem/> */}
                                
                                
                         
                </form>


            </div>
        </div>
    )
}